module.exports = __webpack_public_path__ + "static/img/gm.50fe2799.svg";